import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type TipoEmpresa = '4Comply' | 'Consultoria' | 'Grupo' | 'Empresa Fim' | 'Filial' | null;
export type Theme = 'light' | 'dark';
export type Language = 'pt' | 'es';

interface InterfaceState {
  isSidebarCollapsed: boolean;
  empresaId: number | null;
  usuarioId: number | null;
  tipoEmpresa: TipoEmpresa;
  theme: Theme;
  language: Language;
  toggleSidebar: () => void;
  setEmpresaId: (id: number | null) => void;
  setUsuarioId: (id: number | null) => void;
  setTipoEmpresa: (tipo: TipoEmpresa) => void;
  toggleTheme: () => void;
  setLanguage: (language: Language) => void;
  clearSession: () => void;
}

export const useInterfaceStore = create<InterfaceState>()(
  persist(
    (set) => ({
      isSidebarCollapsed: true,
      empresaId: null,
      usuarioId: null,
      tipoEmpresa: null,
      theme: 'dark',
      language: 'pt',
      toggleSidebar: () => set((state) => ({ isSidebarCollapsed: !state.isSidebarCollapsed })),
      setEmpresaId: (id) => set({ empresaId: id }),
      setUsuarioId: (id) => set({ usuarioId: id }),
      setTipoEmpresa: (tipo) => set({ tipoEmpresa: tipo }),
      toggleTheme: () => set((state) => ({ theme: state.theme === 'dark' ? 'light' : 'dark' })),
      setLanguage: (language) => set({ language }),
      // Idioma é uma preferência do dispositivo/navegador, não da sessão do usuário —
      // não é limpo ao trocar de empresa ou deslogar.
      clearSession: () => set({ empresaId: null, usuarioId: null, tipoEmpresa: null }),
    }),
    {
      name: 'fourhands-session',
      partialize: (state) => ({
        empresaId: state.empresaId,
        usuarioId: state.usuarioId,
        tipoEmpresa: state.tipoEmpresa,
        theme: state.theme,
        language: state.language,
      }),
    }
  )
);
